import request from '../utils/request';

export async function getMeasureDataList(info, user, state, skip, take) {
  return await request(`shopBiz/measurelist?info=${info}&user=${user}&state=${state}&skip=${skip}&take=${take}`, 'get');
}